import Vue from 'vue';

import VueInputDirectives from '@/directives'
Vue.use((VueInputDirectives))


// WEBPACK FOOTER //
// ./src/plugins/inputDirectives.js